import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { teal200, teal300, teal400 } from 'material-ui/styles/colors';

import { switchImageSizeSearchMode } from '../../../actions/UIActions';
import { disableImageSizeSearch, updateImageSize } from '../../../actions/SearchParameter.Actions';
import MultiStateSwitch from '../../../components/MultiStateSwitch';
import Slider from '../../../components/Slider';

class ImageSizeField extends Component {
  constructor(props) {
    super(props);
    this.handleSwitchImageSizeSearchMode = this.handleSwitchImageSizeSearchMode.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.updateImageSize = this.updateImageSize.bind(this);
  }

  componentDidMount() {
    const { history: { location: { search } } } = this.props;
    const parameter = queryString.parse(search);
    if (parameter.imageSizeMode) {
      const { widthSlider, heightSlider } = this;
      widthSlider.forceSetDraggerPosition({
        min: Number(parameter.lowerWidth),
        max: Number(parameter.upperWidth)
      });
      heightSlider.forceSetDraggerPosition({
        min: Number(parameter.lowerHeight),
        max: Number(parameter.upperHeight)
      });
    }
  }

  componentDidUpdate({ imageSizeSearchMode: prevMode }) {
    const { imageSizeSearchMode: currentMode, dispatch } = this.props;
    if (currentMode !== prevMode) {
      if (currentMode === 'disabled') {
        dispatch(disableImageSizeSearch());
      } else {
        this.updateImageSize();
      }
    }
  }

  handleSwitchImageSizeSearchMode({ value }) {
    const { dispatch } = this.props;
    dispatch(switchImageSizeSearchMode(value));
  }

  handleSliderChange() {
    this.updateImageSize();
  }

  updateImageSize() {
    const { dispatch } = this.props;
    const { widthSlider, heightSlider } = this;
    const widthState = widthSlider.getCurrentState();
    const heightState = heightSlider.getCurrentState();

    const { mode } = widthState;

    if (mode !== heightState.mode) {
      console.error('Some problem occured, image width & height mode didn\'t match.');
      return;
    }

    const updatePayload = { mode };

    if (mode === 'range' || mode === 'maximum') {
      updatePayload.width = { min: widthState.min, max: widthState.max };
      updatePayload.height = { min: heightState.min, max: heightState.max };
    } else if (mode === 'exact') {
      updatePayload.width = { min: widthState.value, max: widthState.value };
      updatePayload.height = { min: heightState.value, max: heightState.value };
    }

    dispatch(updateImageSize(updatePayload));
  }

  render() {
    const { imageSizeSearchMode: mode, switchTypes } = this.props;
    const isDisabled = mode === 'disabled';
    const sliderMode = isDisabled ? 'range' : mode;

    return (
      <div className="ImageSizeField">
        <MultiStateSwitch
          types={switchTypes}
          value={mode}
          onStateChange={this.handleSwitchImageSizeSearchMode}
          showHint={false}
        />

        <h4>Image Width</h4>
        <Slider
          ref={(c) => { this.widthSlider = c; }}
          step={10}
          disabled={isDisabled}
          mode={sliderMode}
          boundary={{ min: 0, max: 1440 }}
          onChange={this.handleSliderChange}
        />

        <h4>Image Height</h4>
        <Slider
          ref={(c) => { this.heightSlider = c; }}
          step={10}
          disabled={isDisabled}
          mode={sliderMode}
          boundary={{ min: 0, max: 1440 }}
          onChange={this.handleSliderChange}
        />
      </div>
    );
  }
}

ImageSizeField.defaultProps = {
  switchTypes: [
    {
      title: 'Ignore',
      value: 'disabled',
      fontAwesomeIcon: 'low-vision'
    },
    {
      title: 'Range',
      value: 'range',
      fontAwesomeIcon: 'arrows-h',
      color: teal200
    },
    {
      title: 'Maximum',
      value: 'maximum',
      fontAwesomeIcon: 'long-arrow-right',
      color: teal300
    },
    {
      title: 'Exact',
      value: 'exact',
      fontAwesomeIcon: 'dot-circle-o',
      color: teal400
    }
  ]
};

ImageSizeField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  switchTypes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOf(['Ignore', 'Range', 'Exact', 'Maximum']).isRequired,
    value: PropTypes.oneOf(['disabled', 'range', 'exact', 'maximum']).isRequired,
    fontAwesomeIcon: PropTypes.string.isRequired,
    color: PropTypes.string
  })),
  imageSizeSearchMode: PropTypes.oneOf(['disabled', 'range', 'exact', 'maximum']).isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps({ UI: { imageSizeSearchMode } }) {
  return { imageSizeSearchMode };
}

export default withRouter(connect(mapStateToProps)(ImageSizeField));



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/ImageSizeField.jsx